var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-root"},[(_vm.isLoading)?_c('AppLoader'):_vm._e(),_c('AppNotify'),_c('router-view'),(_vm.isShownWidget)?_c('FeedbackWidget'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }